import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ErrorPage } from "./pages/ErrorPage";
import { Home } from "./pages/Home";
import ReactDOM from "react-dom/client";


function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/*" element={<ErrorPage />} />
        </Routes>
      </div>  
    </BrowserRouter>
  );
}

export default App;
